export default function RequestTrialPage() {
  return (
    <iframe
      src="https://share.hsforms.com/1Koufu6ZETZKZZV6U_d9FNg4uj82"
      style={{ width: "100%", height: "100vh", border: "none" }}
      title="Request a Trial"
    />
  )
}
